export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [5,[2]],
		"/(app)/Dashboard": [6,[2]],
		"/(app)/GeneralInstructions": [7,[2]],
		"/(app)/StudentsManagement": [8,[2]],
		"/(app)/admin": [9,[2,3]],
		"/(app)/admin/settings": [10,[2,3]],
		"/auth": [31],
		"/auth/forgot-password": [32],
		"/auth/reset-password/[token]": [33],
		"/(app)/c/[id]": [11,[2]],
		"/(app)/disclaimers": [12,[2]],
		"/(app)/disclaimers/[id]": [13,[2]],
		"/error": [34],
		"/(app)/popup-acknowledgments": [14,[2]],
		"/(app)/popup-acknowledgments/new": [15,[2]],
		"/(app)/popups": [16,[2]],
		"/(app)/popups/[id]": [17,[2]],
		"/(app)/subscription": [18,[2]],
		"/s/[id]": [35],
		"/(app)/workspace": [19,[2,4]],
		"/(app)/workspace/documents": [20,[2,4]],
		"/(app)/workspace/models": [21,[2,4]],
		"/(app)/workspace/models/create": [22,[2,4]],
		"/(app)/workspace/models/edit": [23,[2,4]],
		"/(app)/workspace/playground": [24,[2,4]],
		"/(app)/workspace/prompts": [25,[2,4]],
		"/(app)/workspace/prompts/create": [26,[2,4]],
		"/(app)/workspace/prompts/edit": [27,[2,4]],
		"/(app)/workspace/tools": [28,[2,4]],
		"/(app)/workspace/tools/create": [29,[2,4]],
		"/(app)/workspace/tools/edit": [30,[2,4]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';